import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { persistor, store } from './store.js'
import { Provider } from 'react-redux'

// we need to initialize the i18n provider
import './i18n';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import "react-datepicker/dist/react-datepicker.css";
import "allotment/dist/style.css";
import { BroadcastProvider } from './common/utils/BroadcastProvider.js';
import { AppStateProvider } from './utils/AppStateProvider.js';
import TopErrorBoundary from './common/components/TopErrorBoundary.js';
import { MessageDisplay } from './common/components/MessageDisplay.js';
import { NetworkStatusMonitor } from './common/hooks/initHook.js';
import { AppProvider } from './common/components/AppProvider.js';
import { PersistGate } from 'redux-persist/integration/react';
import { Spinner } from 'react-bootstrap';
import { setPersistor } from './common/reducers/initContext.js';
import { FormAutofillProvider } from './common/hooks/autofillHook.js';

setPersistor(persistor);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate persistor={persistor} loading={<Spinner></Spinner>}>
        <AppStateProvider>
          <NetworkStatusMonitor>
            <FormAutofillProvider>
              <BroadcastProvider>
                <AppProvider>
                  <TopErrorBoundary>
                    <MessageDisplay>
                      <App />
                    </MessageDisplay>
                  </TopErrorBoundary>
                </AppProvider>
              </BroadcastProvider>
            </FormAutofillProvider>
          </NetworkStatusMonitor>
        </AppStateProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
